import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import StructuredData from "@/components/StructuredData";
import BreadcrumbNav from "@/components/BreadcrumbNav";
import ArticleCard from "@/components/ArticleCard";
import { articles } from "@/data/articles";

const Articulos = () => {
  return (
    <>
      <SEOHead
        title="Artículos sobre Lotería Nicaragua y Costa Rica | TiemposHoy"
        description="Guías, consejos y todo lo que necesitas saber sobre la Diaria Loto de Nicaragua y los Tiempos JPS de Costa Rica."
        keywords="artículos lotería, guía diaria loto, guía tiempos jps, consejos lotería"
        canonicalUrl="https://tiemposhoy.com/articulos"
      />
      <StructuredData
        title="Artículos sobre Lotería - TiemposHoy"
        description="Guías y artículos sobre loterías de Nicaragua y Costa Rica"
      />

      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-1 container mx-auto px-4 py-8">
          <BreadcrumbNav items={[{ label: "Artículos" }]} />

          <header className="mb-10">
            <h1 className="text-3xl md:text-4xl font-bold mb-3">
              Artículos sobre Lotería
            </h1>
            <p className="text-muted-foreground text-lg max-w-2xl">
              Guías, explicaciones y consejos para jugadores de la Diaria Loto de Nicaragua y los Tiempos JPS de Costa Rica.
            </p>
          </header>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article) => (
              <ArticleCard key={article.slug} {...article} />
            ))}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Articulos;
